import { Routes, Route } from "react-router-dom";
import './App.css';
// import CreateAccount from "./pages/createAccount";
// import NavBar from "./components/navBar";
// import DoctorSignUpPage from "./pages/doctorSignUpPage";
// import PatientSignUpPage from "./pages/patientSignUpPage";
import HomePage from "./pages/homePage";

function App() {
  return (
    <>
      {/* <NavBar/> */}
      <Routes>
        <Route path="/" element={<HomePage />} />
        {/* <Route path="/createAccount" element={<CreateAccount />} />
        <Route path="/doctor-signup" element={<DoctorSignUpPage />} />
        <Route path="/patient-signup" element={<PatientSignUpPage />} /> */}
      </Routes>
    </>
  );
}

export default App;
